import { addRoamingInfos } from '@/services/api'
import { ua } from '@/utils/tools'

interface IFileInfo {
  groupid: number
  parentid: number
  fileid: number
  fsize: number
  fname: string

}
export default class AddRoamingRecord {
  fileInfo:IFileInfo
  constructor (fileInfo:IFileInfo) {
    this.fileInfo = fileInfo
  }
  async execute () {
    const { groupid, parentid, fileid, fsize, fname } = this.fileInfo
    const { isMobile, os, browser, wexin, tim } = ua
    let deviceName = browser
    if (wexin) {
      deviceName = 'WeiXin'
    }
    if (tim) {
      deviceName = 'TIM'
    }
    const data = {
      groupid,
      parentid,
      fileid,
      size: fsize,
      name: fname,
      app_type: 'wps',
      operation: 'open',
      status: 'ok',
      current_device_id: isMobile ? 'MO' : 'PC',
      current_device_type: 'Browser',
      current_device_name: `${os} ${deviceName}`
    }
    return addRoamingInfos(data)
  }
}
